module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": "0.2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("备注信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入汇款时间'
      }],
      "label": "汇款时间",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入汇款时间"
    },
    model: {
      value: (_vm.formData.pay_off_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pay_off_date", $$v)
      },
      expression: "formData.pay_off_date"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入汇款订单号'
      }],
      "label": "汇款订单号",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入汇款订单号"
    },
    model: {
      value: (_vm.formData.pay_off_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pay_off_id", $$v)
      },
      expression: "formData.pay_off_id"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "线下支付凭证",
      "value": _vm.formData.order_pics.length + '/2'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.order_pics,
      "limit": 2,
      "name": 'order_pics'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传支付凭证")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d03a5da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/tpage/Tpage1.vue
// module id = 2259
// module chunks = 0